import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { IntegrationDetailPage } from '@/pages/integrations/detail/IntegrationDetailPage'
import { parseProviderIntegrationSearch } from '@/pages/integrations/detail/integration-detail-search'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug'
)({
  validateSearch: parseProviderIntegrationSearch,
  component: ProviderIntegrationDetailRoute,
  staticData: {
    pageHeader: { title: 'Integration', pad: false },
  },
})

function ProviderIntegrationDetailRoute() {
  const { workspaceId, providerSlug } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <IntegrationDetailPage
      workspaceId={workspaceId}
      providerSlug={providerSlug}
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    />
  )
}
